import React, { Component } from "react";
import ACTIONS from "../modules/action";
import { connect } from "react-redux";
import { Col, Row } from "antd";
import styles from './savings-simple.module.scss'
import getMaximumAnnualCost from "../selectors/maximumAnnualCostSelector";
import getMinimumAnnualCost from "../selectors/minimumAnnualCostSelector";
import clipboard from '../images/clipboard.png';
import classNames from "classnames";
import * as ReactDOM from "react-dom";
import debounce from "lodash/debounce";
import data from "../data";
import SliderBasic from "../components/slider-basic";
import Breakdown from "../components/breakdown";
import AnnualSavingsSummary from "../components/annual-savings-summary";
import { Link } from "react-router-dom";
import qs from "query-string"
import choosePlan from "../utils/plan-chooser";

let cx = classNames.bind(styles);

class SavingsSimple extends Component {
    state = {
        sliding: false,
        showDetailedBreakdown: false
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        setTimeout(() => {
            this.calculateStats();
        }, 250);
    }

    componentWillMount() {

        if (this.props.location && this.props.location.state) {
            if (this.props.location.state.genericInk) {
                this.props.changeGenericInk(this.props.location.state.genericInk);
            }

            if (this.props.location.state.highYieldInk) {
                this.props.changeHighYieldInk(this.props.location.state.highYieldInk);
            }

            if (this.props.location.state.pages) {
                this.props.changePages(this.props.location.state.pages);
            }
        }

        if (this.props.location && this.props.location.search) {
            var params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
            if (params.pages) {
                const pages = params.pages;
                let plan = choosePlan(pages);
                this.props.changePages(pages);
                this.props.changePlan(plan);
            }
        }
    }

    onSliderChange = annualCost => {
        this.props.changeAnnualCost(annualCost[0]);
        this.props.changeMonthlyCost(parseFloat((annualCost[0] / 12).toFixed(2)));
        this.setState({ sliding: false });
        this.calculateStats();
    };

    onSliderUpdate = annualCost => {
        this.props.changeAnnualCost(annualCost[0]);
        this.props.changeMonthlyCost(parseFloat((annualCost[0] / 12).toFixed(2)));
        this.setState({ sliding: true });
        this.calculateStats();
    };

    round(value, fixed = false) {
        let output = (Math.round(0.1 * value) / 0.1);
        return fixed ? output.toFixed(0) : output;
    }

    calculateStats = debounce((selectPlan = true, estimatePages = false) => {
        const inks = data.inks;
        const blackAndWhiteOnly = this.props.blackAndWhiteOnly;
        const highYieldInk = this.props.highYieldInk;
        const printer = data.printers.reduce((acc, printer) => {
            if (printer.id === this.props.selectedPrinter) {
                return printer;
            }

            return acc
        }, null);

        const hydratedInks = printer.inks.map((inkId) => inks.filter((ink) => ink.id === inkId)[0]);
        const printerInks = hydratedInks.filter((ink) => {
            return (ink.high_yield === highYieldInk)
        }).filter((ink) => {
            return (ink.generic)
        });

        const inkColor = printerInks.filter(((ink) => ink.type === "color"))[0];
        const inkBlack = printerInks.filter(((ink) => ink.type === "black"))[0];

        let blackToColorRatio = blackAndWhiteOnly ? .85 : .65;
        let totalInks = Math.ceil(this.props.estimatedInkCostPerYear / ((inkBlack.cost + inkColor.cost) / 2));

        console.log('testing', inkColor, inkBlack, blackToColorRatio, totalInks);
        //-- There is always at least one ink of each used
        // let blackInks = Math.floor(totalInks * blackToColorRatio);
        // let colorInks = totalInks - blackInks;

        let blackInks = 2;
        let colorInks = 1;

        //-- Set ink usage per year
        this.props.changeColorInk(colorInks);
        this.props.changeBlackInk(blackInks);

        //-- Take the ink counts and get an average count
        // Here is the thing, they can only technically print the most pages from the highest capacity type, which
        // is always black ink, so lets just use black / color average?
        let pagesPerMonth;
        if (estimatePages) {
            const averageBlackPages = inkBlack.pages * blackInks;
            const averageColorPages = inkColor.pages * colorInks;
            const pagesPerYear = (averageBlackPages + averageColorPages) / 2;
            pagesPerMonth = Math.floor(pagesPerYear / 12);
            this.props.changePages(pagesPerMonth);
        }
        else {
            pagesPerMonth = this.props.pagesPerMonth;
        }


        const yearlyCost = this.props.selectedPlan.priceCents * 12;
        const annualSavings = this.props.estimatedInkCostPerYear - (yearlyCost > 0 ? yearlyCost / 100 : 0.00);


        console.log({
            selectedPlan: this.props.selectedPlan,
            estimatedInkCostPerYear: this.props.estimatedInkCostPerYear,
            pagesPerMonth,
            yearlyCost,
            annualSavings
        });


        this.props.changeAnnualSavings(annualSavings);
        this.props.changePanicTrips(Math.floor((this.props.estimatedBlackInk + this.props.estimatedColorInk) / 2));

        this.forceUpdate();
    }, 50);

    render() {
        return (
            <div>
                <div className={styles.howMuchSave}>
                    <h1 className={styles.header}>See how much you'll save...</h1>
                    <p className={styles.subHeader}>How much do you spend per year on ink?</p>
                    <br/><br/>
                </div>

                <div className={styles.calculateSavings}>
                    <h1 className={styles.header}>
                        Calculate your Savings
                    </h1>
                </div>

                <div className={styles.avgPagesHeader}>
                    <img src={clipboard} alt="clipboard"/>
                    You print {this.props.pagesPerMonth} pages a month on average
                </div>

                <div className={styles.bgAlt}>
                    <div className={styles.topSlider}>
                        <div className={cx(styles.howMuchSpend)}>
                            How much do you roughly spend on ink annually?
                        </div>
                        <div className={styles.topSliderHolderRow}>
                            <div className={styles.topSliderHolderCol}>
                                <Row type="flex" align="middle">
                                    <Col span={1} xs={3}><div className={styles.topSliderLeftNo}>${ this.props.minimumAnnualCost }</div></Col>
                                    <Col span={22} xs={18} className={cx(styles.sliderBasicCol, this.state.sliding ? styles.sliderBasicSliding : '')}><SliderBasic className={styles.sliderBasic}
                                                                        height={3} value={this.props.estimatedInkCostPerYear} domain={[
                                                                            this.props.minimumAnnualCost,
                                                                            this.props.maximumAnnualCost
                                                                        ]}
                                                                        sliderHandleNobClass={styles.sliderHandleNobClass}
                                                                        onChange={(values) => this.onSliderChange(values.slice())}
                                                                        onUpdate={(values) => this.onSliderUpdate(values.slice())}/></Col>
                                    <Col span={1} xs={3}><div className={styles.topSliderRightNo}>${ this.props.maximumAnnualCost }</div></Col>
                                </Row>
                            </div>
                        </div>
                    </div>

                    <div className={styles.detailedBreakdownToggle}
                         onTouchStart={(evt) => this.toggleBreakDown(evt)}
                         onMouseDown={(evt) => this.toggleBreakDown(evt)}
                         onTouchEnd={e => e.preventDefault()}
                    >

                        { this.state.showDetailedBreakdown ? '- Hide detailed breakdown' : '+ Show detailed breakdown' }
                    </div>

                    { this.state.showDetailedBreakdown ? <div>
                        <Breakdown monthlyCost={this.props.estimatedInkCostPerMonth} 
                            pagesPerMonth={this.props.pagesPerMonth}
                            blackInks={this.props.estimatedBlackInk}
                            colorInks={this.props.estimatedColorInk}
                            planId={this.props.selectedPlan.id}
                            planPages={this.props.selectedPlan.pages}
                            planPrice={this.props.selectedPlan.price} />
                    </div> : null }


                </div>

                <AnnualSavingsSummary perYear={this.props.annualInkSavings} panicTrips={this.props.panicTrips}/>
                
                <div className={styles.btnBox}>
                    <a href="https://instantink.hpconnected.com/" className={cx(styles.btn, styles.signUp)}>Try free for 1 month</a>
                </div>
            </div>
        );
    }

    toggleBreakDown(evt) {
        console.log(evt);
        evt.preventDefault();
        evt.stopPropagation();
        this.setState({ showDetailedBreakdown: !this.state.showDetailedBreakdown });
    }
}

const mapStateToProps = (state, props) => ({
    selectedPlan: state.selectedPlan,
    highYieldInk: state.highYieldInk,
    selectedPrinter: state.selectedPrinter,
    pagesPerMonth: state.pagesPerMonth,
    blackAndWhiteOnly: state.blackAndWhiteOnly,
    estimatedBlackInk: state.estimatedBlackInk,
    estimatedColorInk: state.estimatedColorInk,
    estimatedInkCostPerYear: state.estimatedInkCostPerYear,
    estimatedInkCostPerMonth: state.estimatedInkCostPerMonth,
    annualInkSavings: state.annualInkSavings,
    panicTrips: state.panicTrips,
    minimumAnnualCost: getMinimumAnnualCost(state, props),
    maximumAnnualCost: getMaximumAnnualCost(state, props)
});

const mapDispatchToProps = dispatch => ({
    changeGenericInk: choice => dispatch(ACTIONS.changeGenericInk(choice)),
    changeAnnualCost: annualCost => dispatch(ACTIONS.changeAnnualCost(annualCost)),
    changeMonthlyCost: monthlyCost => dispatch(ACTIONS.changeMonthlyCost(monthlyCost)),
    changePages: pagesPerMonth => dispatch(ACTIONS.changePages(pagesPerMonth)),
    changePlan: plan => dispatch(ACTIONS.changePlan(plan)),
    changeInkType: inkType => dispatch(ACTIONS.changeInkType(inkType)),
    changeColorInk: inkCount => dispatch(ACTIONS.changeColorInk(inkCount)),
    changeBlackInk: inkCount => dispatch(ACTIONS.changeBlackInk(inkCount)),
    changeAnnualSavings: amount => dispatch(ACTIONS.changeAnnualSavings(amount)),
    changeHighYieldInk: choice => dispatch(ACTIONS.changeHighYieldInk(choice)),
    changePanicTrips: tripCount => dispatch(ACTIONS.changePanicTrips(tripCount)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SavingsSimple);
